import React, { useEffect, useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { toast } from "sonner";
import { addNewKbCategory, updateKbCategory } from "../../services/axios/apiManager";
import LoadingSpinner from "../../Components/spinner";

const AddKbCategoryModal = ({ show, onHide, onSuccess, editData }) => {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    slug: "",
    description: "",
  });

  useEffect(() => {
    if (editData) {
      setFormData({
        name: editData.name || "",
        slug: editData.slug || "",
        description: editData.description || "",
      });
    } else {
      setFormData({ name: "", slug: "", description: "" });
    }
  }, [editData, show]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => {
      const newData = { ...prev, [name]: value };
      if (name === "name" && !prev.slug && !editData) {
        newData.slug = value
          .trim()
          .toLowerCase()
          .replace(/[^a-z0-9-\s]/g, "")
          .replace(/\s+/g, "-")
          .replace(/-+/g, "-");
      }
      return newData;
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.name || !formData.slug) {
      toast.error("Name and slug are required");
      return;
    }

    setLoading(true);
    try {
      let response;
      if (editData) {
        response = await updateKbCategory({ id: editData.id, ...formData });
      } else {
        response = await addNewKbCategory(formData);
      }

      if (response?.data?.success) {
        toast.success(editData ? "Category updated successfully" : "Category added successfully");
        if (!editData) setFormData({ name: "", slug: "", description: "" });
        if (onSuccess) onSuccess(response.data.data);
        onHide();
      } else {
        toast.error(response?.data?.message || "Failed to save category");
      }
    } catch (error) {
      console.error("Error saving category:", error);
      toast.error("An error occurred while saving the category");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered className="kb-category-modal">
      <Modal.Header closeButton className="bg-dark text-light border-secondary">
        <Modal.Title>{editData ? "Edit Category" : "Add New Category"}</Modal.Title>
      </Modal.Header>
      <Form onSubmit={handleSubmit} role="form">
        <Modal.Body className="bg-dark text-light">
          <Form.Group className="mb-3" controlId="kb-category-name">
            <Form.Label>Category Name</Form.Label>
            <Form.Control
              type="text"
              name="name"
              id="kb-category-name"
              placeholder="e.g. Getting Started"
              className="bg-dark text-light border-secondary"
              value={formData.name}
              onChange={handleChange}
              required
            />
          </Form.Group>
          <Form.Group className="mb-3" controlId="kb-category-slug">
            <Form.Label>Slug</Form.Label>
            <Form.Control
              type="text"
              name="slug"
              id="kb-category-slug"
              placeholder="e.g. getting-started"
              className="bg-dark text-light border-secondary"
              value={formData.slug}
              onChange={handleChange}
              required
            />
          </Form.Group>
          <Form.Group className="mb-3" controlId="kb-category-description">
            <Form.Label>Description</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              name="description"
              id="kb-category-description"
              placeholder="Enter category description..."
              className="bg-dark text-light border-secondary"
              value={formData.description}
              onChange={handleChange}
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer className="bg-dark text-light border-secondary">
          <Button variant="secondary" onClick={onHide} disabled={loading}>
            Cancel
          </Button>
          <Button variant="success" type="submit" disabled={loading}>
            {loading ? <LoadingSpinner size="sm" /> : (editData ? "Save Changes" : "Add Category")}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default AddKbCategoryModal;
